import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import Scroll from 'react-scroll';
import SourceDisplay from 'containers/SettingsModal/SettingsSourceDisplay/SettingsSourceDisplayContainer';
import QualitySelect from 'containers/QualitySelect/QualitySelectContainer';
import classes from './UserSettings.module.scss';
import { isChrome } from 'utils/browser-utils';

const scroll = Scroll.animateScroll;

class UserSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      IEVideoDisabled: false
    };
  }

  render() {
    const {
      hasCamera,
      hasMicrophone,
      showQualityDropdown
    } = this.props;
    if (this.state.IEVideoDisabled) return <div />;
    return (
      <div
        className={classes.container}
        id="userSettingsContainer"
      >
        <header>
          <h1>
            <FormattedMessage
              id="settings.userSettings.avSettings"
              defaultMessage="Audio/Video Settings"
            />
          </h1>
          {!hasCamera && <div>
            <div className={classes.missingCameraText}>
              {hasMicrophone ?
                <FormattedMessage
                  id="settings.userSettings.missingCamera"
                  defaultMessage="We do not have access to your camera. If you proceed with these settings, all of your calls will be audio only."
                /> :
                <FormattedMessage
                  id="settings.userSettings.missingCameraAndMic"
                  defaultMessage="We do not have access to your camera or microphone."
                />
              }
            </div>
            {isChrome() && !window.desktopApp && <div className={classes.missingCameraText}>
              <FormattedMessage
                id="settings.userSettings.chromeInstructions"
                defaultMessage="For the best experience, go to your Chrome settings to allow access. "
              />
              <a href="https://support.google.com/chrome/answer/2693767" rel="noopener noreferrer" target="_blank">
                <FormattedMessage
                  id="settings.userSettings.learnMore"
                  defaultMessage="Learn more."
                />
              </a>
            </div>}
          </div>}
        </header>
        <SourceDisplay />
        <div className={classes.bottomSection}>
          {showQualityDropdown && <QualitySelect
            onOpen={() => {
              scroll.scrollToBottom({
                containerId: this.props.scrollableId,
                smooth: true,
                duration: 200
              });
            }}
          />}
        </div>
      </div>
    );
  }
}

UserSettings.propTypes = {
  hasCamera: PT.bool,
  hasMicrophone: PT.bool,
  showNotificationSettings: PT.bool,
  showQualityDropdown: PT.bool,
  scrollableId: PT.string
};

export default injectIntl(UserSettings);
